import { render, staticRenderFns } from "./modalAdicionalNoturnoBase.vue?vue&type=template&id=5c5c6b13&scoped=true&"
import script from "./modalAdicionalNoturnoBase.vue?vue&type=script&lang=js&"
export * from "./modalAdicionalNoturnoBase.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionalNoturnoBase.vue?vue&type=style&index=0&id=5c5c6b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c6b13",
  null
  
)

export default component.exports